import * as React from 'react';
import { createUseStyles } from 'react-jss';

interface ButtonProps {
    onClick: () => void;
    label: string;
    disabled?: boolean;
    className?: string;
}

const useStyles = createUseStyles({
    button: {
        width: '100%',
        border: '2px solid var(--secondary-color)',
        color: 'var(--secondary-color)',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:disabled': {
            border: '2px solid var(--deactivated-color)',
            color: 'var(--deactivated-color)',
            cursor: 'not-allowed',
        }
    },
});

const Button: React.FC<ButtonProps> = ({ onClick, label, className, disabled = false }: ButtonProps) => {
    const classes = useStyles();

    return (
        <button className={classes.button + (className ? ' ' + className : '')} onClick={onClick} disabled={disabled}>
            {label}
        </button>
    );
};

export default React.memo(Button);
